import { useField } from 'formik'
import styles from './inputs.module.scss'

const CustomRadioGroup = ({
  label,
  options,
  alignColumn,
  onClick,
  disabled = false,
  ...props
}) => {
  const [field, meta] = useField(props)

  return (
    <div>
      <span className="mb-2">{label}</span>
      <div
        className={alignColumn ? styles.radioGroupColumn : styles.radioGroup}
      >
        {options.map((option, index) => {
          const inputId = `${props.name}-${option.value}-${index}` // Generate a unique ID for the input element
          return (
            <div
              key={option.value}
              // className={`d-flex align-items-center `}
              className={`d-flex align-items-center ${
                disabled ? styles.radioDisabled : ''
              }`}
              // onClick={onClick}
              onClick={!disabled ? onClick : undefined}
            >
              <input
                type="radio"
                {...field}
                value={option.value}
                id={inputId}
                checked={field.value === option.value}
                // className={styles.radioSize}
                className={`${styles.radioSize} ${
                  disabled ? styles.radioDisabled : ''
                }`}
                disabled={disabled}
              />
              <label className={`ml-2 ${styles.pointer}`} htmlFor={inputId}>
                {option.label}
              </label>
            </div>
          )
        })}
      </div>
      {meta.touched && meta.error && (
        <div className={styles.error}>{meta.error}</div>
      )}
    </div>
  )
}

export default CustomRadioGroup
